import { render, staticRenderFns } from "./residential-orders.vue?vue&type=template&id=d36809f6&scoped=true"
import script from "./residential-orders.vue?vue&type=script&lang=js"
export * from "./residential-orders.vue?vue&type=script&lang=js"
import style0 from "./residential-orders.vue?vue&type=style&index=0&id=d36809f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36809f6",
  null
  
)

export default component.exports